import React from "react";
import {
  H1,
  H3,
  Button,
  Modal,
  ModalContent,
  ModalFooterButtons,
  Box,
  Text,
} from "@reside/ui";
import {useMutation} from "react-query";
import Alert from "react-s-alert";
import {useEditFacilityModalContext} from "./context";
import {FacilityService} from "../../services/FacilityService";
import {buildResponseErrorMessage} from "../../services/api/errorHelpers";

export const EditFacilityConfirmationModal = () => {
  const {facilityId, fields, toggle} = useEditFacilityModalContext();

  const {mutate, isLoading} = useMutation(
    () => FacilityService.patch(facilityId, fields),
    {
      onSuccess: () => {
        Alert.success(
          "Facility was successfully updated. This change may take a few minutes to be active...",
        );
        toggle();
      },
      onError: async resp => {
        Alert.error(await buildResponseErrorMessage(resp));
        toggle();
      },
    },
  );
  return (
    <Modal
      isOpen={!!facilityId}
      onRequestClose={() => toggle()}
      title="Edit Facility Information"
    >
      {({closeModal}) => (
        <>
          <ModalContent>
            <Text as="p">
              Are you sure you want to update this facility's information?
            </Text>
          </ModalContent>
          <ModalFooterButtons>
            <Button outline color="primary" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              color="success"
              onClick={() => mutate()}
              disabled={!!isLoading}
            >
              {isLoading ? "Loading..." : "Confirm"}
            </Button>
          </ModalFooterButtons>
        </>
      )}
    </Modal>
  );
};
